import { Component, computed, effect, inject, OnInit, signal } from '@angular/core';

import { AppInfoService, AuthService } from 'src/app/shared/services';
import { environment } from 'src/environments/environment';


/**
 *
 */
@Component({
  templateUrl: 'home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent  {

  private readonly appInfo = inject(AppInfoService);
  private readonly authService = inject(AuthService);
  public readonly isProduction = signal(environment.production);
  public readonly userInfo$ =  this.authService.userInfo$;
  public readonly appVersion = signal(this.appInfo.AppVersion);
  public readonly backgroundImageUrl = signal('');
/** Abgeleiteter Zustand: Begrüßungstext */
  public readonly greeting = computed(() => {
    const hour = new Date().getHours();
    if (hour >= 4 && hour < 10) return 'Guten Morgen, ';
    if (hour >= 10 && hour < 18) return 'Guten Tag ';
    if (hour >= 18 && hour < 22) return 'Guten Abend';
    return 'Zeit zum Schlafen';
  });


  /**
   *
   */
  constructor() {
    effect(() => {
      const random = Math.floor(Math.random() * 11) + 1;
      this.backgroundImageUrl.set(`/assets/moodimages/mood${random}.jpg`);
    });
  }



}
